"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var d3 = require("d3");

var SitePlotAxis = /*#__PURE__*/function (_React$Component) {
  _inherits(SitePlotAxis, _React$Component);

  var _super = _createSuper(SitePlotAxis);

  function SitePlotAxis() {
    _classCallCheck(this, SitePlotAxis);

    return _super.apply(this, arguments);
  }

  _createClass(SitePlotAxis, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.data != null) {
        this.createPlotAxis();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.data != null) {
        d3.select(".baseSitePlotAxis").html("");
        this.createPlotAxis();
      }
    }
  }, {
    key: "createPlotAxis",
    value: function createPlotAxis() {
      var _this$props = this.props,
          data = _this$props.data,
          label_width = _this$props.label_width,
          padding = _this$props.padding;
      var label_width = this.props.label_width;
      var max_value = this.props.max_value || d3.max(data);
      var padding = this.props.padding;
      var height = this.props.height - padding.bottom;
      var plot_axis = d3.axisLeft().scale(d3.scaleLinear().domain([max_value, 0]).range([0, height]));
      var axis = d3.select(".baseSitePlotAxis").attr("width", label_width).attr("height", height + padding.bottom);
      axis.append("g").attr("class", "axis").attr("transform", "translate(".concat(label_width - 1, ", ").concat(padding.top, ")")).call(plot_axis);
      axis.append("text").attr("transform", "rotate(-90)").attr("y", label_width / 2).attr("x", -padding.top - height / 2).style("text-anchor", "middle").text(this.props.axis_label);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("g", {
        className: "baseSitePlotAxis",
        transform: "translate(".concat(this.props.translateX, ", ").concat(this.props.translateY, ")"),
        width: this.props.label_width,
        height: this.props.height,
        id: this.props.id + "-sitePlotAxis"
      });
    }
  }]);

  return SitePlotAxis;
}(_react["default"].Component);

SitePlotAxis.defaultProps = {
  id: "alignmentjs",
  padding: {
    top: 10,
    right: 0,
    bottom: 15,
    left: 5
  },
  sender: "main",
  label_width: 30,
  translateX: 0,
  translateY: 0
};
var _default = SitePlotAxis;
exports["default"] = _default;